import React, { useEffect, useRef } from "react";

import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
// import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { IoMdPrint } from "react-icons/io";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../../_helper/helper";
import { PRINT_ACCESS } from "../../../_contstants/common";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getKarigarWiseJadaiAmountPhineSummaryReport } from "../services/reports.services";
import { sumBy } from "lodash";

const JadaiKarigarLedgerReportView: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const fromdate = params.fromdate;
  const todate = params.todate;
  const karigar_id = params.karigar_id;
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.reports.loading);
  const KarigarWiseJadaiAmountPhineSummaryReportList = useAppSelector(
    (state) => state.reports.KarigarWiseJadaiAmountPhineSummaryReportList,
  );

  const isPrintAccess = checkAcessRights(
    "/jadai-karigar-ledger-report",
    PRINT_ACCESS,
  );

  const fetchKarigarWiseJadaiAmountPhineSummaryReport = async (
    payload: any,
  ) => {
    await dispatch(getKarigarWiseJadaiAmountPhineSummaryReport(payload));
  };

  useEffect(() => {
    if (fromdate && todate && karigar_id) {
      const payload = {
        karigar_id: karigar_id,
        from_date: fromdate,
        to_date: todate,
      };
      fetchKarigarWiseJadaiAmountPhineSummaryReport(payload);
    }
  }, []);

  const printTable = () => {
    window.print();
    return;
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <GridLayoutItem>
            <div
              className="printbuttons"
              style={{
                textAlign: "center",
                padding: "20px",
                display: "block",
              }}
            >
              {/* {isExcelExportAccess && (
                <Button
                  type="button"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handleExportExcel}
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                    backgroundColor: "#3b823b",
                  }}
                >
                  <PiMicrosoftExcelLogoFill style={{ fontSize: "20px" }} />{" "}
                  Excel Export
                </Button>
              )} */}
              {isPrintAccess && (
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={printTable}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              )}
            </div>
          </GridLayoutItem>
          <GridLayoutItem>
            <Typography.h5
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              Jadai Karigar Ledger Report
            </Typography.h5>
            <Typography.h6
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              (
              {fromdate
                ? moment(fromdate, "YYYY-MM-DD").format("DD/MM/YYYY")
                : ""}
              {" to "}
              {todate ? moment(todate, "YYYY-MM-DD").format("DD/MM/YYYY") : ""})
            </Typography.h6>
            <Typography.h5
              style={{
                textAlign: "center",
                fontSize: "18px",
              }}
            >
              Karigar:{" "}
              {
                KarigarWiseJadaiAmountPhineSummaryReportList?.[0]
                  ?.karigar_name
              }
            </Typography.h5>
          </GridLayoutItem>
          {/* REPORT LIST */}
          {KarigarWiseJadaiAmountPhineSummaryReportList &&
          KarigarWiseJadaiAmountPhineSummaryReportList.length > 0 ? (
            <div className="karigar-phine-ledger">
              <div className="table-container">
                <table className="ledger-table">
                  <thead>
                    <tr>
                      <th className="text-center" style={{ width: "5%" }}>
                        Order No
                      </th>
                      <th className="text-center" style={{ width: "7%" }}>
                        Issue Date
                      </th>
                      <th className="col-desc" style={{ width: "18%" }}>
                        Particular
                      </th>
                      <th className="text-end" style={{ width: "6%" }}>
                        Ghat Weight
                      </th>
                      <th className="text-end" style={{ width: "7%" }}>
                        Gross Weight
                      </th>
                      <th className="text-center" style={{ width: "6%" }}>
                        Stone Qty
                      </th>
                      <th className="text-end" style={{ width: "6%" }}>
                        Rate
                      </th>
                      <th className="text-end" style={{ width: "6%" }}>
                        Extra
                      </th>
                      <th className="text-end" style={{ width: "7%" }}>
                        Total Rs
                      </th>
                      <th className="text-center" style={{ width: "6%" }}>
                        Kundan
                      </th>
                      <th className="text-end" style={{ width: "6%" }}>
                        Phine
                      </th>
                      <th className="text-end" style={{ width: "7%" }}>
                        Rs Paid
                      </th>
                      <th className="text-end" style={{ width: "7%" }}>
                        Balance Phine
                      </th>
                      <th className="text-end" style={{ width: "6%" }}>
                        Balance Rs.
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {KarigarWiseJadaiAmountPhineSummaryReportList.map(
                      (data, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "even-row" : "odd-row"}
                        >
                          <td className="cell-date text-center">
                            {data?.order_no}
                          </td>
                          <td className="cell-date text-center">
                            {data?.Date}
                          </td>
                          <td
                            className="cell-desc"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {index === 0 ? `Opening Balance` : data?.item_name}
                          </td>
                          <td className="text-end">
                            {(data?.ghat_weight &&
                              formatWeight(data?.ghat_weight)) ||
                              ""}
                          </td>
                          <td className="text-end">
                            {(data?.gross_weight &&
                              formatWeight(data?.gross_weight)) ||
                              ""}
                          </td>
                          <td className="text-center">
                            {data?.stone_qty || ""}
                          </td>
                          <td
                            className="cell-issue"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {data?.rate
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.rate,
                                )
                              : ""}
                          </td>
                          <td
                            className="cell-issue"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {data?.extra_cost
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.extra_cost || 0,
                                )
                              : ""}
                          </td>
                          <td
                            className="cell-issue"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {data?.TotalRs
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.TotalRs || 0,
                                )
                              : ""}
                          </td>
                          <td className="text-center">{data?.kundan || ""}</td>
                          <td
                            className="cell-receipt text-nowrap"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {(index !== 0 && formatWeight(data?.Phine)) || ""}{" "}
                            {data.creditdebittypephine === "Credit"
                              ? index !== 0 && "Cr"
                              : index !== 0 && "Dr"}
                          </td>
                          <td
                            className="cell-balance text-nowrap"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {index !== 0 &&
                              formatToIndianCurrencyWithoutSymbol(
                                data?.RSPaid || 0,
                              )}{" "}
                            {data.creditdebittypeamount === "Credit"
                              ? index !== 0 && "Cr"
                              : index !== 0 && "Dr"}
                          </td>
                          <td
                            className="cell-balance text-nowrap"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {formatWeight(
                              index !== 0
                                  ? data?.closing_phine
                                  : data?.phine_opening_balance,
                            )}{" "}
                            {data.creditdebittypephine === "Credit"
                              ? "Cr"
                              : "Dr"}
                          </td>
                          <td
                            className="cell-balance text-nowrap"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {formatToIndianCurrencyWithoutSymbol(
                              index !== 0
                                ? data?.closing_amount || 0
                                : data?.amount_opening_balance || 0,
                            )}{" "}
                            {data.creditdebittypeamount === "Credit"
                              ? "Cr"
                              : "Dr"}
                          </td>
                        </tr>
                      ),
                    )}
                  </tbody>
                  <tfoot>
                    <tr className="totals-row">
                      <td colSpan={3} className="totals-label">
                        TOTALS
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseJadaiAmountPhineSummaryReportList,
                            "ghat_weight",
                          )
                        )}
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseJadaiAmountPhineSummaryReportList,
                            "gross_weight",
                          )
                        )}
                      </td>
                      <td className="total-issue text-end">
                        {sumBy(
                          KarigarWiseJadaiAmountPhineSummaryReportList,
                          "stone_qty",
                        )}
                      </td>
                      <td colSpan={8}></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          ) : null}
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default JadaiKarigarLedgerReportView;
